import Vue from 'vue'
import axios from 'axios'
import store from '../store'

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || ''

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  baseURL: process.env.baseURL || process.env.apiUrl || 'https://trayllo.com.br/wp-json/trayllo/v1/',

  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  c => {
    const token = localStorage.token
    if (token) {
      c.headers.Authorization = `Bearer ${token}`
    }
    store.commit('setLoading', true)

    // Do something before request is sent
    return c
  },
  error => {
    // Do something with request error
    if (typeof error.response.data === 'string') {
      Vue.$toast.error(error.response.data)
    }
    store.commit('setLoading', false)

    return Promise.reject(error)
  },
)

// Add a response interceptor
_axios.interceptors.response.use(
  response => {
    // Do something with response data
    if (response.data.jwt_auth_invalid_token) {
      delete localStorage.token
      location.href = '/login'
    }
    store.commit('setLoading', false)

    return response
  },
  error => {
    // Do something with response error
    if (error.response) {
      if (error.response.status == 403) {
        delete localStorage.token
        setTimeout(() => location.href = '/login', 500)
      }
      if (typeof error.response.data === 'string') {
        Vue.$toast.error(error.response.data)
      }
    }
    store.commit('setLoading', false)

    return Promise.reject(error)
  },
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      },
    },
    $axios: {
      get() {
        return _axios
      },
    },
  })
}

Vue.use(Plugin)

export default Plugin
